import { Check } from 'lucide-react';
import { dayKey, parseDay, weekDays } from '../lib/day';

interface Props {
  practiceDays: string[];
  target: number;
  now?: Date;
}

/** This week at a glance, against a forgiving weekly target rather than a streak. */
export function WeekDots({ practiceDays, target, now = new Date() }: Props) {
  const days = weekDays(now);
  const today = dayKey(now);
  const done = days.filter((d) => practiceDays.includes(d)).length;
  const left = Math.max(0, target - done);
  const days_ = (n: number) => `${n} ${n === 1 ? 'day' : 'days'}`;
  const message =
    done >= target
      ? `${done} of ${days_(target)}. You've hit this week's target.`
      : done === 0
        ? target === 1
          ? 'Aim for 1 day this week. Any day will do.'
          : `Aim for ${days_(target)} this week. Any ${target} will do.`
        : `${done} of ${days_(target)} this week. ${left} more whenever suits you.`;
  return (
    <div className="stack">
      <div className="week" role="list" aria-label="This week">
        {days.map((d) => {
          const date = parseDay(d);
          const isDone = practiceDays.includes(d);
          const label = date.toLocaleDateString('en-GB', { weekday: 'short' });
          return (
            <div key={d} className="week-day" role="listitem" data-done={isDone} data-today={d === today} aria-label={`${date.toLocaleDateString('en-GB', { weekday: 'long' })}${isDone ? ', practised' : ''}${d === today ? ', today' : ''}`}>
              <span className="week-dot">{isDone && <Check size={16} strokeWidth={3} aria-hidden="true" />}</span>
              <span aria-hidden="true">{label.slice(0, 2)}</span>
            </div>
          );
        })}
      </div>
      <p className="small muted">{message}</p>
    </div>
  );
}
